import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default function useRecordCollectionBulkEditorToolbarActions(
  items,
  selectedItems
) {
  const store = useStore();
  const route = useRoute();

  const deleteRecordCollections = async () => {
    if (!confirm("Are you sure you want to delete this?")) return;

    // Create a list of columnIDs from selectedItems
    const selectedColumnIDs = selectedItems.value.map((item) => item.columnID);

    const itemsToKeep = items.value.filter((item) => {
      const shouldKeep = !selectedColumnIDs.includes(item.columnID);
      return shouldKeep;
    });

    await store.dispatch("api/patchCategory", {
      path: `/category/${route.params.categoryID}`,
      patch: { recordColumns: itemsToKeep },
    });
    await store.dispatch("setStoreVar", {
      page: "Category",
      group: "page",
      type: "recordColumns",
      name: "recordColumns",
      value: itemsToKeep,
    });
  };

  return {
    deleteRecordCollections,
  };
}
